import React, { Component } from 'react';
import PropTypes from 'prop-types';
import functions from "../../api/functions.js";
import { api } from "../../api/api.js";
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

export const CartContext = React.createContext();

class CartProvider extends Component {
	constructor(props) {
		super(props);
		this.state = {
			selectedItems: [],
			loading: false,
			formaPagoID: 0,
		}
	}

	static propTypes = {
		selectedItems: PropTypes.array,
		children: PropTypes.any,
	}

	componentDidMount() {
		this.load();
	}

	decode() {
		let cart = localStorage.getItem('cartItems');
		if (cart) {
			let result = JSON.parse(atob(cart));
			return Array.isArray(result) ? result : [];
		} else {
			return false;
		}
	}

	load() {
		// Prefer server-side cart; fallback to localStorage
		functions.get(api.cart.base, null, 1, null, (data) => {
			try {
				const productos = (data && data.data && data.data.productos) ? data.data.productos : [];
				const items = productos.map(p => ({ code: p.code, quantity: p.quantity }));
				this.setItems(items);
			} catch (e) {
				let decoded = this.decode();
				if (decoded) this.setState({ selectedItems: decoded });
			}
		}, () => {
			let decoded = this.decode();
			if (decoded) this.setState({ selectedItems: decoded });
		});
	}

	setItems(items) {
		localStorage.removeItem('cartItems');
		localStorage.setItem('cartItems', btoa(JSON.stringify(items)));
		setTimeout(() => {
			this.setState(
				prevState => {
					prevState.selectedItems = items;
					return prevState;
				}
			);
		}, 100);
		return true;
	}

	encode() {
		const { selectedItems } = this.state;
		return btoa(JSON.stringify(selectedItems));
	}

	save() {
		localStorage.setItem('cartItems', this.encode());
		let cart = localStorage.getItem('cartItems');
		if (cart != undefined && cart != null && cart != '') {
			functions.post(api.perfil.saveCart, 1, { cartItems: cart });
		};
	}

	setItem(code, quantity, callback) {
		if (quantity && !isNaN(quantity)) {
			// Persist absolute quantity to server, then mirror locally
			functions.post(api.cart.items, null, { code: code, cantidad: quantity, set: true }, (data) => {
				const { selectedItems } = this.state;
				let items = selectedItems.filter(x => x.code === code);
				if (items.length) {
					this.setState(prevState => {
						prevState.selectedItems.filter(x => x.code === code).forEach(x => { x.quantity = quantity; });
						return prevState;
					}, () => { this.save(); if (callback) callback(); });
				} else {
					this.setState(prevState => { prevState.selectedItems.push({ code: code, quantity: quantity }); return prevState; }, () => { this.save(); if (callback) callback(); });
				}
			});
		} else {
			this.removeItem(code, callback);
		}
	}

	refreshUnderCriteria(criteria, callback) {
		const selectedItems = this.state.selectedItems.filter(item => criteria(item));
		let encoded = btoa(JSON.stringify(selectedItems));

		this.setState(initialPrevState => {
			initialPrevState.loading = true;
			return initialPrevState;
		}, () => {
			functions.get(api.pedidos.generar.carrito, encoded, 1, null, (data) => {
				if (callback) callback(data);
				this.setState(prevState => {
					prevState.loading = false;
					return prevState;
				})
			});
		})
	}

	buyItem(code, quantity, callback) {
		let productsInCart = this.state.selectedItems;
		let issetInCart = productsInCart.find(product => product.code === code);

		const respNo = () => { return null; };

		const respSi = () => {
			if (quantity && !isNaN(quantity)) {
				const { selectedItems } = this.state;
				let items = selectedItems.filter(x => x.code === code);
				if (items.length) {
					this.setState(prevState => {
						prevState.selectedItems.filter(x => x.code === code).forEach(x => {
							x.quantity += quantity;
						});
						return prevState;
					}, () => {
						this.save();
						if (callback) callback();
					});
				} else {
					this.setState(prevState => {
						prevState.selectedItems.push({ code: code, quantity: quantity });
						return prevState;
					}, () => {
						this.save();
						if (callback) callback();
					});
				}
			} else {
				this.removeItem(code, callback);
			}
			window.location.replace("/#/cart/");
		};

		if (issetInCart != undefined) {
			confirmAlert({
				title: 'Producto repetido',
				message: 'El producto ya fue cargado en el carrito  ¿Quiere seguir agregando más unidades?',
				buttons: [
					{
						label: 'Sí',
						onClick: () => respSi()
					},
					{
						label: 'No',
						onClick: () => respNo()
					}
				]
			});
		} else {
			respSi();
		}
	}

	removeItem(code, callback) {
		functions.delete(api.cart.itemByCode, null, (data) => {
			const { selectedItems } = this.state;
			let items = selectedItems.filter(x => x.code === code);
			if (items.length) {
				this.setState(prevState => {
					prevState.selectedItems = prevState.selectedItems.filter(x => x.code !== code);
					return prevState;
				}, () => { this.save(); if (callback) callback(); });
			}
		}, null, null, { code: code });
	}

	removeItems(codes, callback) {
		const { selectedItems } = this.state;
		let items = selectedItems.filter(x => codes.filter(y => y === x.code).length);
		if (items.length) {
			this.setState(prevState => {
				prevState.selectedItems = prevState.selectedItems.filter(x => codes.filter(y => y === x.code).length === 0);
				return prevState;
			}, () => {
				this.save();
				if (callback) callback();
			});
		}
	}

	getQuantity(code = null) {
		const { selectedItems } = this.state;
		if (code) {
			let items = selectedItems.filter(x => x.code === code);
			if (items.length)
				return items.map(x => x.quantity).reduce((a, b) => a + b);
			else
				return 1;
		}
		else
			return selectedItems.map(x => x.quantity).reduce((a, b) => a + b);
	}

	getItems(callback) {
		this.setState(initialPrevState => { initialPrevState.loading = true; return initialPrevState; }, () => {
			functions.get(api.cart.base, null, 1, {}, (data) => {
				const _data = data;
				callback && callback(_data)
				this.setState(prevState => { prevState.loading = false; return prevState; })
			});
		});
	}

	isItemPresent(code = null) {
		const { selectedItems } = this.state;
		let items = selectedItems.filter(x => x.code === code);
		return items.length > 0;
	}

	render() {
		const { selectedItems, loading } = this.state;
		const { children } = this.props;
		return (
			<CartContext.Provider value={{
				selectedItems: selectedItems,
				quantity: (code) => this.getQuantity(code),
				setItem: (code, quantity, callback) => this.setItem(code, quantity, callback),
				buyItem: (code, quantity, callback) => this.buyItem(code, quantity, callback),
				removeItem: (code, callback) => this.removeItem(code, callback),
				removeItems: (codes, callback) => this.removeItems(codes, callback),
				items: (callback) => this.getItems(callback),
				loading: loading,
				refresh: (criteria, callback) => this.refreshUnderCriteria(criteria, callback),
				isItemPresent: (code) => this.isItemPresent(code),
				setItems: (items) => this.setItems(items),
				clear: () => this.setItems([]),
			}}>
				{children}
			</CartContext.Provider>
		)
	}
}

export default CartProvider;



// WEBPACK FOOTER //
// ./src/components/ParadigmaCartProvider/ParadigmaCartProvider.js